import { LabeledInput } from '@/components/ra-inputs/LabeledInput';
import { TextInput as RaTextInput, TextInputProps } from 'react-admin';

function TextInput(props: TextInputProps): JSX.Element {
  return (
    // @ts-ignore
    <LabeledInput {...props}>
      {/* @ts-ignore */}
      <RaTextInput />
    </LabeledInput>
  );
}

export { TextInput };
export type { TextInputProps };
